import axios from "axios";
import * as types from "../redux/actions/actionTypes";
import * as authHelpers from "./authHelpers";

export function setupInterceptors(store) {
  axios.interceptors.request.use(
    (config) => {
      // perform a task before the request is sent   

      let user = JSON.parse(localStorage.getItem("AUTH_USER"));
      if (user?.token) config.headers.Authorization = `Bearer ${user.token}`;

      return config;
    },
    (error) => {
      // handle the error
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      // do something with the response data 

      return response;
    },
    (error) => {
      var response = error.response;
      var redirect = authHelpers.checkErrorResponseForRedirect(response);

      if (redirect) {
        store.dispatch({
          type: types.authRedirect,
          redirect: redirect,
        });
      }
          
      // handle the response error
      return Promise.reject(error);
    }
  );
}
